import React from 'react';
import {
    IconWarning,
    TitleMessage,
    ToastColumn,
    ToastMessage,
    ToastWrapper,
    IconAlert,
    IconCheckCircle
} from './styles';

interface IToast{
    type?:string;
    title:string;
    description:string;
}

function ToastComponent({type,title, description}:IToast){
    return(
        <ToastWrapper>
          <IconWarning>
            {type==='success' ? <IconCheckCircle />  : <IconAlert className='toast-icon' /> }
          </IconWarning>
          <ToastColumn>
            <TitleMessage>{ title }</TitleMessage>
            <ToastMessage>
              { description }
            </ToastMessage>
          </ToastColumn>
        </ToastWrapper>
    )
}

export default ToastComponent;